export const debounce = <T extends (...args: any[]) => void>(fn: T, delay: number = 250) => {
  let timeoutId: ReturnType<typeof setTimeout>;
  const debounce = (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn(...args), delay);
  };
  debounce.cancel = () => {
    clearTimeout(timeoutId);
  };

  return debounce;
};
